"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.StatusText = exports.StatusBlock = exports.ButtonText = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var styles = exports.styles = {
  table: {
    borderCollapse: 'separate',
    width: 'calc(100% - 10px)',
    borderSpacing: 8,
    backgroundColor: '#fff',
    fontFamily: 'Backpack, Helvetica Neue, Helvetica, Arial, sans-serif',
    maxWidth: '580px',
    margin: 'auto'
  }
};
var Button = exports.Button = _styledComponents["default"].button.attrs(function (_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type;
  return {
    type: type
  };
}).withConfig({
  displayName: "styles__Button",
  componentId: "sc-1p42ciu-0"
})(["color:#007aff;background-color:", ";border:1px solid #007aff;border-radius:2px;box-sizing:border-box;width:100%;height:fit-content;cursor:pointer;position:relative;padding:6px;min-height:48px;"], function (_ref2) {
  var color = _ref2.color;
  return color;
});
var ButtonText = exports.ButtonText = _styledComponents["default"].p.withConfig({
  displayName: "styles__ButtonText",
  componentId: "sc-1p42ciu-1"
})(["font-size:16px;line-height:20px;transition:opacity 200ms;transition-delay:", ";width:100%;opacity:", ";margin:0;"], function (_ref3) {
  var loading = _ref3.loading;
  return loading ? '0ms' : '200ms';
}, function (_ref4) {
  var loading = _ref4.loading;
  return loading ? 0 : 1;
});
var StatusBlock = exports.StatusBlock = _styledComponents["default"].div.withConfig({
  displayName: "styles__StatusBlock",
  componentId: "sc-1p42ciu-2"
})(["font-family:inherit;font-size:16px;line-height:18px;width:100%;height:164px;display:flex;flex-direction:column;align-items:center;justify-content:space-evenly;padding:8px;background-color:", ";box-sizing:border-box;"], function (_ref5) {
  var success = _ref5.success;
  return success ? '#F1F7D2' : '#F9EAEC';
});
var StatusText = exports.StatusText = _styledComponents["default"].div.withConfig({
  displayName: "styles__StatusText",
  componentId: "sc-1p42ciu-3"
})(["text-align:center;margin-bottom:8px;"]);